/*
 * jf-agotado guard: bloquea desde el tema el agregar al carrito de variantes de productos con el tag jf-agotado.
 * Los variant IDs los publica Liquid con <span hidden data-jf-agotado-ids="id,id"> (snippet jf-agotado, output 'ids').
 * Se lee el DOM en cada intento, así que funciona con contenido cargado después (filtros, quick view, drawer).
 * No cubre /cart/<variante>:1 ni llamadas externas al tema.
 */
(function () {
  'use strict';

  var MESSAGE_ES = 'Este producto está agotado';
  var MESSAGE_EN = 'This product is sold out';
  var ADD_PATH = /\/cart\/add(\.js|\.json)?$/;

  function message() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? MESSAGE_EN : MESSAGE_ES;
  }

  function blockedIds() {
    var ids = {};
    var nodes = document.querySelectorAll('[data-jf-agotado-ids]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].getAttribute('data-jf-agotado-ids').split(',').forEach(function (id) {
        id = id.trim();
        if (id) ids[id] = true;
      });
    }
    return ids;
  }

  function anyBlocked(list) {
    if (!list || !list.length) return false;
    var blocked = blockedIds();
    return list.some(function (id) { return blocked[String(id).trim()] === true; });
  }

  function isAddUrl(url) {
    try {
      return ADD_PATH.test(new URL(String(url), window.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function idsFromEntries(entries) {
    var ids = [];
    entries.forEach(function (pair) {
      if (/^id$/.test(pair[0]) || /^items\[\d*\]\[id\]$/.test(pair[0])) ids.push(pair[1]);
    });
    return ids;
  }

  function idsFromJson(data) {
    var ids = [];
    var items = Array.isArray(data) ? data : (data && Array.isArray(data.items) ? data.items : [data]);
    items.forEach(function (item) {
      if (item && item.id !== undefined) ids.push(item.id);
    });
    return ids;
  }

  function idsFromBody(body) {
    try {
      if (body == null) return [];
      if (typeof FormData !== 'undefined' && body instanceof FormData) return idsFromEntries(Array.from(body.entries()));
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return idsFromEntries(Array.from(body.entries()));
      if (typeof body === 'string') {
        var text = body.trim();
        if (text.charAt(0) === '{' || text.charAt(0) === '[') return idsFromJson(JSON.parse(text));
        return idsFromEntries(Array.from(new URLSearchParams(text).entries()));
      }
    } catch (e) {}
    return [];
  }

  function notify() {
    try {
      var existing = document.getElementById('jf-agotado-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.id = 'jf-agotado-toast';
      toast.setAttribute('role', 'alert');
      toast.textContent = message();
      toast.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;max-width:90vw;padding:12px 20px;border-radius:999px;background:#141414;color:#fff;font:600 14px/1.3 sans-serif;text-align:center;box-shadow:0 4px 16px rgba(0,0,0,.25)';
      (document.body || document.documentElement).appendChild(toast);
      setTimeout(function () { toast.remove(); }, 3500);
    } catch (e) {}
  }

  function blockedResponse() {
    notify();
    return new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: message() }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function guardFetch(original) {
    var guarded = function (input, init) {
      var args = arguments;
      var self = this;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || String(input);
        if (isAddUrl(url)) {
          if (init && init.body != null) {
            if (anyBlocked(idsFromBody(init.body))) return Promise.resolve(blockedResponse());
          } else if (typeof Request !== 'undefined' && input instanceof Request) {
            return input.clone().text().then(function (text) {
              return anyBlocked(idsFromBody(text)) ? blockedResponse() : original.apply(self, args);
            }, function () {
              return original.apply(self, args);
            });
          }
        }
      } catch (e) {}
      return original.apply(self, args);
    };
    guarded.__jfAgotadoGuard = true;
    return guarded;
  }

  // El layout guarda el fetch nativo en __jfNativeFetch y js-jf-native-cart.js lo restaura en window.fetch,
  // así que se envuelven los dos para que la restauración no quite el guard.
  if (typeof window.fetch === 'function') {
    var base = typeof window.__jfNativeFetch === 'function' ? window.__jfNativeFetch : window.fetch.bind(window);
    if (!base.__jfAgotadoGuard) {
      var guarded = guardFetch(base);
      window.__jfNativeFetch = guarded;
      window.fetch = guarded;
    }
  }

  if (window.XMLHttpRequest) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__jfAgotadoAdd = isAddUrl(url);
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (this.__jfAgotadoAdd && anyBlocked(idsFromBody(body))) {
        var xhr = this;
        notify();
        setTimeout(function () { xhr.dispatchEvent(new ProgressEvent('error')); }, 0);
        return;
      }
      return xhrSend.apply(this, arguments);
    };
  }

  // Formularios de producto: se cortan antes de que lleguen al listener del tema.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute || form.tagName !== 'FORM' || !isAddUrl(form.getAttribute('action') || form.action)) return;
    var ids;
    try {
      ids = idsFromEntries(Array.from(new FormData(form).entries()));
    } catch (e) {
      return;
    }
    if (anyBlocked(ids)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      notify();
    }
  }, true);
})();
